import React, { useState } from 'react'
import { Typography, Menu, MenuItem } from '@material-ui/core'
import classNames from 'classnames'
import useStyles from './styles'
import Button from '_components/button'

import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons'

export function DropDownButton({
  label,
  disabled = false,
  localDisabled = false,
  options = [],
  onSelect,
  icon = null,
}) {
  const styles = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)

  const open = Boolean(anchorEl)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <div>
      <Button
        id={`${label}-button`}
        key={label}
        className={classNames(styles.button, styles.secondButton)}
        onClick={handleClick}
        color="primary"
        variant="outlined"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        disabled={disabled || localDisabled}
        startIcon={icon}
        endIcon={open ? <ArrowDropUp /> : <ArrowDropDown />}
      >
        <Typography>{label}</Typography>
      </Button>

      <Menu
        id={`${label}-menu`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': `${label}-button`,
        }}
        PaperProps={{
          style: {
            marginTop: 40,
            marginLeft: 8,
          },
        }}
      >
        {options.map(option => (
          <MenuItem
            key={option.value}
            onClick={() => {
              onSelect?.(option.value)
              handleClose()
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}
